import React from 'react';
import { FinalFormField } from '../../common/Form/FinalFormField';
import { FinalFormFieldProps } from '../../common/Form/types';
import { Select, Props as SelectProps } from './Select';
import { Option } from './types';

export function FinalFormSelect<T extends Option>(props: FinalFormFieldProps & SelectProps<T>) {
  return (
    <FinalFormField {...props}>
      {({ input, ...rest }: FinalFormFieldProps) => (
        <Select
          data-test-error={!!rest.hintError}
          data-test-error-message={rest.hintError}
          {...input}
          {...rest}
          value={(props.options || []).find(option => option.value === input.value)}
          onChange={(value: T) => input.onChange(value?.value)}
        />
      )}
    </FinalFormField>
  );
}
